module.exports = __webpack_public_path__ + "img/shopLogo.3199d8d7.png";